import { months } from '../../../_helpers/Constants';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React from 'react';


export function reportsFincenterActsColumn({ t, language,onDownloadAct,history }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('reportsPage_periodMonth'),
      accessor: 'periodMonth',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ value }) => {
        if (!value) return '';
        const monthCode = value.split('-')[1];
        const month = months.find(m => m.code === monthCode);
        return month ? month[language] : '';
      }
    },
    {
      Header: t('reportsPage_fincenterActNumber'),
      accessor: 'fincenterActNumber',
      style: { textAlign: 'center' },
      filterable: false,
    },
    {
      Header: `${t('reportsPage_fincenterPaymentAmount')} (₸)`,
      accessor: 'paymentAmount',
      style: { textAlign: 'center' },
      filterable: false,
      Cell: ({ value }) => (value != null ? value : ''),
    },
    {
      Header: t('reportsPage_fincenterActCreatedDate'),
      accessor: 'createdAt',
      Cell: row =>
        row.original.createdAt
          ? moment(row.original.createdAt).format('DD.MM.YYYY / HH:mm')
          : '',
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('contingentPage_actions'),
      style: { textAlign: 'center', alignSelf: 'center' },
      filterable: false,
      Cell: ({ original }) => (
        <div style={{ margin: '-5px 0', display: 'flex', justifyContent: 'center', gap: 5 }}>
          {/* Кнопка просмотра */}
          <Tooltip placement="top" title={t('reportsPage_fincenterActionView')}>
            <IconButton
              color="primary"
              size="small"
              onClick={e => {
                e.stopPropagation();
                if (history) history.push(`/fincenter-act/${original.id}`);
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          {/* Кнопка скачивания */}
          <Tooltip placement="top" title={t('contingentPage_download')}>
            <IconButton
              color="primary"
              size="small"
              onClick={e => {
                e.stopPropagation();
                onDownloadAct(original.documentId);
              }}
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];
}
